import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback } from 'react';
import { BestBuy, Signer } from '@tokenlon/sdk';
import { updateRefreshToken } from "../../../state/application/reducer";
import { useAppDispatch } from "../../../state/hooks";
import { updateBestBuySubmitStatus } from "../../../state/dex/actions";
import { BestBuySubmitStatus } from "../../../state/dex/type";
import { captureException } from '@sentry/nextjs';
import { useWeb3React } from '@web3-react/core';
export var useCancelBestBuyOrder = () => {
  var _useWeb3React = useWeb3React(),
      account = _useWeb3React.account,
      provider = _useWeb3React.provider,
      chainId = _useWeb3React.chainId;

  var dispatch = useAppDispatch();
  return useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(order) {
      var signer, sig, cancelBestBuyRequest;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(updateBestBuySubmitStatus(BestBuySubmitStatus.CancelOrderPending));
              signer = new Signer(provider, 'web');
              _context.prev = 2;
              _context.next = 5;
              return signer.signCancelBestBuy([order.orderHash]);

            case 5:
              sig = _context.sent;
              cancelBestBuyRequest = {
                chainId,
                orderHashes: [order.orderHash],
                cancelSig: sig
              };
              _context.next = 9;
              return BestBuy.cancelBestBuyOrder(cancelBestBuyRequest);

            case 9:
              dispatch(updateRefreshToken(+new Date()));
              dispatch(updateBestBuySubmitStatus(BestBuySubmitStatus.CancelOrderSuccess));
              _context.next = 17;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);

              if (_context.t0 && Number(_context.t0.code) === 4001) {
                dispatch(updateBestBuySubmitStatus(BestBuySubmitStatus.CancelOrderRejected));
              } else {
                dispatch(updateRefreshToken(+new Date()));
                dispatch(updateBestBuySubmitStatus(BestBuySubmitStatus.CancelOrderFailure));
                captureException(_context.t0);
              }

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 13]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [account, provider, chainId]);
};